var _path, _circle, _line, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaPolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a48605b9-3e74-4e69-9412-871f964a8f54",
    "data-name": "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,9.82,26.71A11,11,0,0,1,4,17V4A2,2,0,0,1,6,2H26a2,2,0,0,1,2,2V17a11,11,0,0,1-5.82,9.71ZM6,4V17a9,9,0,0,0,4.77,7.94L16,27.73l5.23-2.79A9,9,0,0,0,26,17V4Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "a8eaf007-c521-413e-80c6-4241e4af12e7",
    "data-name": " Transparent Rectangle ",
    width: 32,
    height: 32,
    style: {
      fill: "none"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.01,
    cy: 17.01,
    r: 1.99
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 19,
    y2: 17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19,14a3,3,0,0,0-1.29.3l-2-2A2.87,2.87,0,0,0,16,11a3,3,0,1,0-3,3,3,3,0,0,0,1.29-.3l2,2A3,3,0,0,0,16,17a3,3,0,1,0,3-3Zm-7-3a1,1,0,1,1,1,1A1,1,0,0,1,12,11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaPolicy);
export default __webpack_public_path__ + "static/media/CA_policy.a86292df90a9bfd1eec21afacd7d05fb.svg";
export { ForwardRef as ReactComponent };